<template>
    <div class="topicIndex spackage padding-20 bgc box-shadow">
        <!-- start 顶部菜单栏 -->
        <section class="startMgt-header">
            <el-button type="primary" align="left" @click="addNewTopic()">新建话题</el-button>
            <div align="right" style="float:right">
                <el-input placeholder="输入话题名称" v-model="searchName" style="width: 240px"></el-input>
                <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
            </div>
        </section>
        <!-- end 顶部菜单栏 -->
        <section>
            <el-table :data="topicData">
                <el-table-column type="index" width="50" label="序号"></el-table-column>
                <el-table-column prop="tagname" label="话题名称" align="center"></el-table-column>
                <el-table-column label="操作" align="right">
                    <template slot-scope="scope">
                        <div class="table-position">
                            <span @click="delClick(scope.row.innerid)">删除</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <page :total="total" ref="page" @getList="searchClick"></page>
        </section>
        <!-- start 新建弹窗 -->
        <el-dialog title="新增话题" :visible.sync="dialogFormVisible">
            <el-form :model="form">
                <el-form-item label="话题名称" :label-width="formLabelWidth">
                    <el-input v-model="activeName" autocomplete="off"  clearable maxlength="10" show-word-limit></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="sureAdd()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- end 新建弹窗 -->
    </div>
</template>

<script>
    import {getTopicList,saveTopic,delTopic} from '@/api/communityApi'
    import Loading from 'base/loading/loading' // 引入 loading 组件
    import {mapGetters,mapActions} from 'vuex'
    import Page from 'base/page/page'
    export default {
        name: "topicMgt",
        data() {
            return {
                loading: false, // 加载
                dialogFormVisible: false,
                formLabelWidth: '80px',
                activeName:'', //话题名称
                total: 0,   //表格页数
                topicData:[],   //表格数据
                searchName:'', //搜索话题
                form:{

                }
            }
        },
        components: {
            Loading,
            Page
        },
        mounted() {
            this.setLoading(true);
            this.apiData = {
                starid:this.$route.query.innerid,
                page: 1,
                pageSize: 10
            };
            this.topicMgtEvent()
        },
        methods: {
            handleQuery() {
                this.$refs.page.handleSizeChange(1)
            },
            ...mapActions([
                'setLoading'
            ]),
            // 新建话题
            addNewTopic() {
                this.activeName = '';
                this.dialogFormVisible = true
            },
            // 确定添加话题
            sureAdd() {
                this.setLoading(true);
                let params = {
                    starid:this.$route.query.innerid,
                    tagname: this.activeName
                };
                saveTopic({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.dialogFormVisible = false;
                        this.$message({type: 'success', message: '添加成功！'});
                        this.topicMgtEvent()
                    },
                    error: data => {
                        console.log('error：', data);
                        this.setLoading(false);
                        this.dialogFormVisible = false;
                        this.$message.error(data.msg)
                    }
                })
            },
            // 删除话题
            delClick(id) {
                this.$confirm('删除后将不可恢复，确认删除吗？', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    let params = {
                        starid:this.$route.query.innerid,
                        tagid: id,
                    };
                    this.setLoading(true);
                    delTopic({
                        data: Object.assign({}, params),
                        success: data => {
                            this.setLoading(false);
                            this.topicMgtEvent();
                            this.$message.success(`删除成功!`)
                        },
                        error: data => {
                            this.setLoading(false);
                            console.log('error：', data);
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
            },
            //话题列表
            topicMgtEvent() {
                getTopicList({
                    data: this.apiData,
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.topicData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            // 搜索
            searchClick() {
                this.setLoading(true);
                let params = {
                    tagname: this.searchName,
                    starid:this.$route.query.innerid,
                };
                getTopicList({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        this.setLoading(false);
                        this.topicData = data.data.content
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        console.log('error：', data)
                        this.setLoading(false)
                    }
                })
            },
        },
        computed: {
            ...mapGetters([
                'page',
                'user'
            ])
        },
    }
</script>

<style scoped lang="scss">
    .topicIndex {
        display: flex;
        flex-direction: column;
    }
    .startMgt-header {
        width: 100%;
        height: 40px;
        margin-bottom: 12px;
        .el-button {
            height: 32px;
        }
        .el-input {
            margin-right: 20px;
        }
    }
    .table-position{
        white-space: nowrap;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        span{
            color: #409EFF;
            cursor: pointer;
        }
    }
</style>
